import React from "react";
import { getSpacingClassName } from "@qlik/qlik/src/lib/util/spacing";
import { getColorClassName } from "@qlik/qlik/src/lib/util/colors";
import Media from "@qlik/qlik/src/components/Media";

const Signature = ({ data }) => {
    const { cardItem: card, additionalConfiguration, backgroundColor, customId } = data ?? {};
    const spacingClassName = getSpacingClassName(additionalConfiguration, "pt-3.5");
    const { sectionColorMapping } = getColorClassName(backgroundColor);
    return (
        <section className={`${spacingClassName} ${sectionColorMapping?.bgColor || "bg-white"}`} id={customId}>
            <div className="container">
                {card?.mediaIcon && <Media className="mb-3.75 w-[135px]" media={card?.mediaIcon} />}
                {card?.title && <div className="title-5 text-gray mb-1.75">{card?.title}</div>}
                {card?.subtitle && <div className="body text-sm tracking-normal">{card?.subtitle}</div>}
            </div>
        </section>
    );
};

export default Signature;
